module.exports = __webpack_public_path__ + "assets/share-edit.bd608143.svg";